module.exports = __webpack_public_path__ + "static/media/chica-sonriendo.2acac643.jpg";